/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_All_Team_MembersInputs */



/**
* | output |
* | --- |
* | "All Team Members" |
*
* @param {Knp_Guide_All_Team_MembersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_all_team_members = /** @type {((inputs?: Knp_Guide_All_Team_MembersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_All_Team_MembersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les membres de l’équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Teammitglieder")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i membri del team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все члены команды")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los miembros del equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有团队成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームメンバー全員")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी टीम सदस्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todos os membros da equipe")
	return /** @type {LocalizedString} */ ("All Team Members")
});